'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { ForgotPasswordForm } from '@/features/auth/components/forgot-password-form'
import { useAuth } from '@/providers/auth-provider'
import { PageLoading } from '@/components/common/page-loading-state'

export default function ForgotPasswordPage() {
  const { user, isLoading } = useAuth()
  const router = useRouter()

  useEffect(() => {
    if (user) {
      router.replace('/dashboard')
    }
  }, [user, router])

  return (
    <div className="flex min-h-svh flex-col items-center justify-center bg-muted p-6 md:p-10">
      <div className="w-full max-w-sm">
        {isLoading || user ? <PageLoading /> : <ForgotPasswordForm />}
      </div>
    </div>
  )
}
